import React from 'react';
import { FormattedMessage, useIntl } from '@atlassian/jira-intl';
import type {
	Flag as KnowledgeCommonFlag,
	KnowledgeCommonFlagMessage,
} from '../../../common/types';
import { useFlagData } from '../../store';

export const useKnowledgeCommonFlagHook = (messages: KnowledgeCommonFlagMessage) => {
	const { formatMessage } = useIntl();
	const [{ id, type, title, description }, { resetDraftArticleData }] = useFlagData(messages);
	const knowledgeCommonflags: KnowledgeCommonFlag[] = id
		? [
				{
					description: typeof description === 'string' ? '' : <FormattedMessage {...description} />,
					flagType: type,
					id,
					title: formatMessage(title),
				},
			]
		: [];
	return [knowledgeCommonflags, resetDraftArticleData] as const;
};
